import React, { useContext, useState } from "react";
import { CommonContext } from "hooks/CommonContext";
import MessageComponent from "./components/MessageComponent";
import { getCurrentTime } from "utils/commonUtils";
import ChatInputWithEmojis from "./components/ChatInputWithEmojis";

const GroupChat = () => {
  const [inputText, setInputText] = useState("");
  const {
    groupMessagesData,
    userOwnData,
    room_id,
    socketRef,
    addMessageToGroup,
  } = useContext(CommonContext);

  function groupChatHandler() {
    if (inputText.trim() !== "") {
      const current_time = getCurrentTime();
      const newMessage = {
        username: userOwnData.username,
        message: inputText,
        isOwnMessage: true,
        time: current_time,
      };

      addMessageToGroup(newMessage);

      socketRef.current.emit("group_new_message", {
        message: inputText,
        username: userOwnData.username,
        room_id: room_id,
        guid: userOwnData.guid,
      });
      setInputText("");
    }
  }

  return (
    <React.Fragment>
      <div className="messages-chat-box p-4" id="messages">
        {groupMessagesData?.map((item, index) => (
          <MessageComponent
            key={item.message + item.time + item.username}
            userName={item.username}
            sentTime={item.time}
            textMessage={item.message}
            isOwnMessage={item.isOwnMessage}
          />
        ))}
      </div>

      <ChatInputWithEmojis
        inputText={inputText}
        setInputText={setInputText}
        onSendMessage={groupChatHandler}
      />
    </React.Fragment>
  );
};

export default GroupChat;
